import { render, staticRenderFns } from "./MenuButtons.vue?vue&type=template&id=82e7ec38&scoped=true&"
import script from "./MenuButtons.vue?vue&type=script&lang=js&"
export * from "./MenuButtons.vue?vue&type=script&lang=js&"
import style0 from "./MenuButtons.vue?vue&type=style&index=0&id=82e7ec38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e7ec38",
  null
  
)

component.options.__file = "MenuButtons.vue"
export default component.exports